<template>
  <div>
    <dx-data-grid
      :show-borders="true"
      :ref="'batch-child-grid-' + templateData.key"
      :columns="columns"
      :data-source="dataSource"
      @toolbar-preparing="onDetailsToolbarPreparing($event)"
      @row-removed="onRowRemoved"
      @cell-prepared="onCellPrepared"
    >
      <DxSearchPanel :visible="false" />
      <template #use-by-cell-template="{ data }">
        <gc-friendly-date :date="data.data.UseByDate" />
      </template>
    </dx-data-grid>
  </div>
</template>
<script>
import { DxDataGrid } from "devextreme-vue/data-grid";
import BaseViewMixin from "../../src/v1/_mixins/base.view";

export default {
  components: { DxDataGrid },
  props: {
    templateData: {
      type: Object,
      default: () => {},
    },
    parentModel: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      dataSource: this.templateData.data.StocktakeReviewBatches,
    };
  },
  methods: {},
};
</script>
<style>
.master-detail-caption {
  padding: 0 0 5px 10px;
  font-size: 14px;
  font-weight: bold;
}
</style>
